export function formatDate(dateString: string): string {
  try {
    // If the date string doesn't have a timezone indicator, assume it's UTC
    let normalizedDateString = dateString;
    if (
      dateString &&
      !dateString.endsWith('Z') &&
      !dateString.includes('+') &&
      !dateString.includes('-', 10)
    ) {
      normalizedDateString = dateString + 'Z';
    }

    const date = new Date(normalizedDateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch {
    return dateString || 'N/A';
  }
}
